export enum Language {
  eng = "english",
  kor = "korean"
}